import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface MicrophoneState {
  microphoneStream: MediaStream | null;
  isMicOn: boolean;
  setMicrophoneStream: (stream: MediaStream | null) => void;
  clearMicrophoneStream: () => void;
  setIsMicOn: (isMicOn: boolean) => void;
  resetMicrophoneState: () => void;
}

export const useMicrophoneStore = create<MicrophoneState>()(
  persist(
    (set, get) => ({
      microphoneStream: null,
      isMicOn: false,
      setMicrophoneStream: (stream) => set({ microphoneStream: stream }),
      clearMicrophoneStream: () => {
        const current = get().microphoneStream;
        if (current) {
          // Stop all tracks before clearing
          current.getTracks().forEach((track) => track.stop());
        }
        set({ microphoneStream: null });
      },
      setIsMicOn: (isMicOn) => set({ isMicOn }),
      resetMicrophoneState: () => {
        const current = get().microphoneStream;
        if (current) {
          // Stop all tracks before clearing
          current.getTracks().forEach((track) => track.stop());
        }
        set({ microphoneStream: null, isMicOn: false });
      },
    }),
    {
      name: 'microphone-store',
      // Only persist the isMicOn state, not the stream (which can't be serialized)
      partialize: (state) => ({ isMicOn: state.isMicOn }),
    },
  ),
);
